import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { operationStatus, damageCategories } from '@/mocks/homeData';

export default function HeroSection() {
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState('사이트명');
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <section className="relative bg-secondary-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20navy%20blue%20gradient%20background%20with%20subtle%20geometric%20patterns%20and%20soft%20red%20light%20accents%2C%20digital%20security%20theme%2C%20minimalist%20modern%20composition%2C%20professional%20web%20banner&width=1600&height=500&seq=onkapan-hero-bg-001&orientation=landscape"
          alt="hero background"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/50 via-secondary-950/30 to-secondary-950/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="flex-1">
            <div className="mb-6">
              <span className="text-primary-500 font-bold text-lg md:text-xl">스카연</span>
              <h1 className="text-2xl md:text-3xl font-bold text-white mt-1">
                먹튀검증·피해예방 커뮤니티
              </h1>
              <p className="text-foreground-300 text-sm md:text-base mt-3 max-w-xl leading-relaxed">
                이용자 제보와 검증을 기반으로 먹튀 피해를 예방하고 안전한 이용 문화를 만들어가는
                커뮤니티입니다.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-2 mb-6">
              <select
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
                className="bg-secondary-800 text-white text-sm px-4 py-3 rounded border border-secondary-700 focus:outline-none focus:border-primary-500"
              >
                <option>사이트명</option>
                <option>도메인</option>
              </select>
              <div className="flex flex-1">
                <input
                  type="text"
                  placeholder="검색어를 입력하세요. (예: 미니게임, richbet.com)"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleKeyDown}
                  className="flex-1 bg-secondary-800 text-white text-sm px-4 py-3 rounded-l border border-secondary-700 focus:outline-none focus:border-primary-500"
                />
                <button
                  onClick={handleSearch}
                  className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-r transition-colors font-medium"
                >
                  검색
                </button>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-6">
              {damageCategories.map((cat) => (
                <button
                  key={cat.label}
                  className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap ${
                    cat.active
                      ? 'bg-primary-500 text-white'
                      : 'bg-secondary-800 text-foreground-300 hover:bg-secondary-700 hover:text-white'
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/search"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-6 py-3 rounded-md transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line" />
                검증 시작하기
              </Link>
              <a
                href="/#verification"
                className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white text-sm font-semibold px-6 py-3 rounded-md transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line" />
                더 알아보기
              </a>
            </div>
          </div>

          <div className="w-full lg:w-72 bg-secondary-900/80 backdrop-blur-sm rounded-lg border border-secondary-800 p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-white font-semibold text-sm">스카연 운영 현황</h3>
              <span className="text-xs text-foreground-400">2026.07.03 기준</span>
            </div>
            <div className="space-y-3">
              {operationStatus.map((item) => (
                <div key={item.label} className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-primary-500 text-sm" />
                    <span className="text-sm text-foreground-300">{item.label}</span>
                  </div>
                  <span className="text-sm font-semibold text-white">{item.value}</span>
                </div>
              ))}
            </div>
            <a
              href="/#verification"
              className="block w-full mt-4 text-center text-xs text-primary-500 hover:text-primary-400 transition-colors cursor-pointer"
            >
              운영 현황 및 담당 결과 자세히 보기 →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}